import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { actions as routerActions } from "redux-router5";
// import * as Routes from "modules/routing/routes";

import { getHelpTexts } from "modules/entity-repository/entity-repository-selectors";
import { getLocale } from "modules/i18n/locale-selectors";

import constants from "../../common/constants";
import { sanitizeHTMLString } from "../utils/text-utils";
import { getLocaleSpecificProp } from "../i18n/locale-utils";

class Guidance extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    helpText: PropTypes.object,
    onNext: PropTypes.func.isRequired,
    goTo: PropTypes.func.isRequired
  };

  state = {
    activeTab: constants.information
  };

  getHelpText = () => {
    const { helpText, locale } = this.props;

    return sanitizeHTMLString(
      getLocaleSpecificProp(helpText.information, locale)
    );
  };

  render() {
    const { helpText } = this.props;
    if (!helpText) {
      return null;
    }

    return (
      <Fragment>
        <div className="modal consent-modal">
          <div className="consent-wrapper custom">
            <div className="title">
              <FormattedMessage id="app.show-help" />
            </div>
            <div
              className="consent-text"
              dangerouslySetInnerHTML={{
                __html: this.getHelpText()
              }}
            />
          </div>
        </div>
        <div className="next">
          <button className="Button--round" onClick={this.props.onNext}>
            <FormattedMessage id="app.got-it" />
          </button>
        </div>
      </Fragment>
    );
  }
}

const mapState = state => ({
  helpTexts: getHelpTexts(state),
  locale: getLocale(state)
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  helpText: stateProps.helpTexts[ownProps.type]
});

const mapDispatch = {
  goTo: routerActions.navigateTo
};

export default connect(
  mapState,
  mapDispatch,
  mergeProps
)(Guidance);



// WEBPACK FOOTER //
// ./src/modules/general-info/guidance.js